import { useStore } from '@/store/useStore';
import { useBetOnRacer } from '@/ui/hooks/useBetOnRacer';
import { Spacer } from '@/ui/components/base';
import { LeaderboardItem } from './LeaderboardItem/LeaderboardItem';
import { WinScreen } from './WinScreen/WinScreen';
import { useShowTimers } from './useShowTimers';
import { cn } from '@/ui/lib/utils';
import './raceResults.css';

const SHOW_POSITIONS = ['1st', '2nd', '3rd'];

export const RaceResults = () => {
    const racersBetCounts = useStore((state) => state.racersBetCounts);
    const racers = useStore((state) => state.activeHeroes.sort((a, b) => a.position - b.position));
    const stateTick = useStore((state) => state.stateTick);
    const bet = useStore((state) => state.bet);
    const betOnRacer = useBetOnRacer();
    const isFirstPlace = betOnRacer?.position === '1st';
    const { showWinScreen, showLeaderboard } = useShowTimers(isFirstPlace);

    return (
        <div className="race-results">
            <div className="race-results__overlay"></div>

            <WinScreen show={showWinScreen} amount={(betOnRacer?.multiplier ?? 0) * bet} />

            {showLeaderboard && (
                <div className="race-results__container">
                    <div className="race-results__content">
                        {betOnRacer && isFirstPlace && (
                            <img
                                className="race-results__winner-card"
                                src={`assets/images/${betOnRacer.racerId}-win.png`}
                                alt="winners racer card"
                            />
                        )}

                        <div className="race-results__leaderboard-container">
                            {betOnRacer && SHOW_POSITIONS.includes(betOnRacer.position) && (
                                <h1
                                    className={cn(
                                        'race-results__position',
                                        isFirstPlace && 'race-results__position--first',
                                    )}
                                >
                                    {betOnRacer.position} Place!
                                </h1>
                            )}

                            <div className="race-results__leaderboard">
                                {racers.map((racer) => (
                                    <LeaderboardItem
                                        key={racer.name}
                                        rank={racer.position}
                                        racerId={racer.name}
                                        bet={betOnRacer?.racerId === racer.name}
                                        betsCount={racersBetCounts[racer.name] ?? 0}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    <Spacer variant="vertical" min={8} max={40} />

                    <div className="race-results__count-down">
                        <span className="race-results__count-down-text">
                            Choose your next racer in
                        </span>
                        <span className="race-results__count-down-number">
                            {Math.round((100 - stateTick) / 10)}
                        </span>
                    </div>

                    <Spacer variant="vertical" min={8} max={16} />
                </div>
            )}
        </div>
    );
};
